import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import ProductSampleStoragePage from '@/v2/components/pages/public-pages/product-sample-storage-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/product-sample-storage-page'

interface ProductSampleStoragePageProps {}

const Page: React.FC<ProductSampleStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.product_sample_storage.title ?? ''}
        keywords={META_CONTENTS.product_sample_storage?.keywords ?? ''}
        description={META_CONTENTS.product_sample_storage?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <ProductSampleStoragePage />
    </>
  )
}

export default Page
